import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    SmsDripEditionFragment as SmsDripEdition,
    GetSmsDripEdition as GetSmsDripEditionQuery,
    GetSmsDripEditionVariables as GetSmsDripEditionQueryVariables,
} from 'nutshell-graphql-types';

import GET_SMS_DRIP_EDITION from '../queries/get-sms-drip-edition.graphql';

export const useGetSmsDripEdition = (
    dripEditionId?: string | null
): {
    smsDripEdition: SmsDripEdition | null | undefined;
    isLoading: boolean;
    errorMessage: string | null | undefined;
} => {
    const {data, error, loading} = useQuery<
        GetSmsDripEditionQuery,
        GetSmsDripEditionQueryVariables
    >(GET_SMS_DRIP_EDITION, {
        skip: !dripEditionId,
        // @ts-expect-error
        variables: {editionId: dripEditionId},
        fetchPolicy: 'cache-and-network',
    });

    const smsDripEdition = data ? data.smsDripEdition : null;

    return {
        // Checking typename because otherwise I'm pretty sure that flow is unhappy that the edition query could return non-drip editions
        smsDripEdition,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        isLoading: loading,
    };
};
